import React from 'react';
import PropTypes from 'prop-types';
import './RecordCollectionContentTypeTag.css';
import {useTranslation} from 'react-i18next';
import { Badge } from 'react-bootstrap';

const RecordCollectionContentTypeTag = ({ label, status, loading = false }) => {
    const { t } = useTranslation();

    const content = (() => {
        if (status === 'not_selected') return t('content_type_not_selected');
        if (status === 'missing') return t('content_type_missing');
        if (status === 'has_content' && label) {
            const translatedLabel = `content_type_${String(label).toLowerCase()}`;
            return t(translatedLabel);
        }
        return t('content_type_missing');
    })();

    return (
        <div className="record-collection-content-type-inheritance-message">
            {t('record_collection_content_type')}
            {loading ? (
                <span className="record-collection-content-type-loading" role="status">{t('loading')}</span>
            ) : (
                <Badge className="record-tag record-collection-content-type-tag" bg="dark" aria-label={content}>
                    {content}
                </Badge>
            )}
        </div>
    );
};

RecordCollectionContentTypeTag.propTypes = {
    label: PropTypes.string,
    status: PropTypes.oneOf(['not_selected', 'missing', 'has_content']).isRequired,
    loading: PropTypes.bool,
};

export default RecordCollectionContentTypeTag;
